// Mirrors horizon/server/src/services/ticketLookup.js `parseTicketLookupQuery`.
// The client only uses it to decide whether to offer "Open ticket"; the server
// decides what the text means for the MSP's PSA and whether the ticket exists.

const MAX_QUERY_LENGTH = 64;
const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const AUTOTASK_TICKET_NUMBER_PATTERN = /^T?\d{8}\.\d{1,6}$/i;
const INTEGER_PATTERN = /^\d{1,12}$/;
const PREFIXED_INTEGER_PATTERN = /^[A-Z]{1,6}-?\d{3,12}$/i;

/** The search text with a leading `#` removed, or "" when it cannot be a ticket ID. */
export function ticketLookupText(raw: string): string {
  const text = raw.trim().replace(/^#\s*/, "");
  if (!text || text.length > MAX_QUERY_LENGTH) return "";
  const isTicketId =
    AUTOTASK_TICKET_NUMBER_PATTERN.test(text) ||
    UUID_PATTERN.test(text) ||
    INTEGER_PATTERN.test(text) ||
    PREFIXED_INTEGER_PATTERN.test(text);
  return isTicketId ? text : "";
}
